export enum AccountClosedByStatuses {
    UNSET = 'UNSET',
    CLOSED_DATE = 'CLOSED_DATE',
    STATUS_CODE = 'STATUS_CODE',
    CLOSED_DATE_OR_STATUS_CODE = 'CLOSED_DATE_OR_STATUS_CODE',
    CLOSED_DATE_AND_STATUS_CODE = 'CLOSED_DATE_AND_STATUS_CODE',
}

export default AccountClosedByStatuses;
